'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: ', 'px;\n  bottom: 0;\n  height: 60px;\n  position: absolute;\n  background: #f7f7f7;\n  box-shadow: ', ';\n  @media (max-width: ', 'px) {\n    width: 100%;\n  }\n'], ['\n  width: ', 'px;\n  bottom: 0;\n  height: 60px;\n  position: absolute;\n  background: #f7f7f7;\n  box-shadow: ', ';\n  @media (max-width: ', 'px) {\n    width: 100%;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  cursor: pointer;\n  height: 50px;\n  background: ', ';\n  box-shadow: none;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &:hover, &:active {\n    background: ', ';\n  }\n'], ['\n  cursor: pointer;\n  height: 50px;\n  background: ', ';\n  box-shadow: none;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &:hover, &:active {\n    background: ', ';\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  right: 30px;\n  top: 50%;\n  transform: translateY(-50%);\n'], ['\n  position: absolute;\n  right: 30px;\n  top: 50%;\n  transform: translateY(-50%);\n']),
    _templateObject4 = _taggedTemplateLiteral(['padding: 10px 20px 0 20px;'], ['padding: 10px 20px 0 20px;']),
    _templateObject5 = _taggedTemplateLiteral(['\n  margin-right: auto;\n  @media (max-width: ', 'px) {\n    display: none;\n  }\n'], ['\n  margin-right: auto;\n  @media (max-width: ', 'px) {\n    display: none;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['@media (max-width: ', 'px) {display: none;}'], ['@media (max-width: ', 'px) {display: none;}']),
    _templateObject7 = _taggedTemplateLiteral(['\n  margin-right: auto;\n  display: none;\n  @media (max-width: ', 'px) {\n    display: inline;\n  }\n'], ['\n  margin-right: auto;\n  display: none;\n  @media (max-width: ', 'px) {\n    display: inline;\n  }\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  display: none;\n  @media (max-width: ', 'px) {\n    display: inline;\n  }\n'], ['\n  display: none;\n  @media (max-width: ', 'px) {\n    display: inline;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../../helpers');

var _nitroText = require('../nitro-text');

var _nitroText2 = _interopRequireDefault(_nitroText);

var _nitroIcon = require('../nitro-icon');

var _nitroIcon2 = _interopRequireDefault(_nitroIcon);

var _nitroButton = require('../nitro-button');

var _nitroButton2 = _interopRequireDefault(_nitroButton);

var _nitroButtonGroup = require('../nitro-button-group');

var _nitroButtonGroup2 = _interopRequireDefault(_nitroButtonGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DrawerAction = _styledComponents2.default.div(_templateObject, function (props) {
  return props.width;
}, function (props) {
  return props.open && '0 -2px 4px 0 rgba(0,0,0,0.1)';
}, function (props) {
  return props.width;
});

DrawerAction.displayName = 'DrawerAction';
var FooterAction = DrawerAction.extend(_templateObject2, function (props) {
  return props.theme.color[props.variant];
}, function (props) {
  return (0, _helpers.darkenColor)(props.theme.color[props.variant]);
});

var FooterActionIcon = _styledComponents2.default.div(_templateObject3);

FooterActionIcon.displayName = 'FooterActionIcon';
var DrawerButtonGroup = _styledComponents2.default.div(_templateObject4);

DrawerButtonGroup.displayName = 'DrawerButtonGroup';
var LeftActionGroup = _styledComponents2.default.div(_templateObject5, function (props) {
  return props.width;
});
LeftActionGroup.displayName = 'LeftActionGroup';
var RightActionGroup = _styledComponents2.default.div(_templateObject6, function (props) {
  return props.width;
});

RightActionGroup.displayName = 'RightActionGroup';
var ShortLeftActionGroup = _styledComponents2.default.div(_templateObject7, function (props) {
  return props.width;
});
ShortLeftActionGroup.displayName = 'ShortLeftActionGroup';
var ShortRightActionGroup = _styledComponents2.default.div(_templateObject8, function (props) {
  return props.width;
});

ShortRightActionGroup.displayName = 'ShortRightActionGroup';
var getActions = function getActions(actions, labelVariant) {
  return actions.map(function (action) {
    return _react2.default.createElement(_nitroButton2.default, {
      key: 'filter-action-' + action.label,
      variant: action.variant,
      size: 'compact',
      label: action.label,
      action: action.action,
      disabled: action.disabled,
      labelVariant: labelVariant
    });
  });
};

var getShortActions = function getShortActions(actions, labelVariant) {
  return actions.map(function (action) {
    return _react2.default.createElement(_nitroButton2.default, {
      key: 'filter-action-' + action.label,
      variant: action.variant,
      size: 'compact',
      label: action.shortLabel || action.label,
      action: action.action,
      disabled: action.disabled,
      labelVariant: labelVariant
    });
  });
};

var NitroDrawerFooter = function NitroDrawerFooter(_ref) {
  var actions = _ref.actions,
      width = _ref.width,
      isOpen = _ref.isOpen,
      close = _ref.close,
      action = _ref.action,
      actionLabel = _ref.actionLabel,
      cancelAction = _ref.cancelAction,
      cancelLabel = _ref.cancelLabel,
      labelVariant = _ref.labelVariant,
      actionFooter = _ref.actionFooter;

  var footerActions = actions || {};
  var left = footerActions.left || [];
  var right = footerActions.right || [{
    label: cancelLabel || 'Cancel',
    action: cancelAction || close
  }, {
    label: actionLabel || 'Apply',
    action: action,
    variant: 'secondary'
  }];

  if (actionFooter) {
    var variant = actionFooter.variant,
        label = actionFooter.label,
        _action = actionFooter.action,
        icon = actionFooter.icon;


    return _react2.default.createElement(
      FooterAction,
      { width: width, open: isOpen, variant: variant, onClick: _action },
      _react2.default.createElement(
        _nitroText2.default,
        { variant: 'white', size: '4', bold: true },
        label
      ),
      _react2.default.createElement(
        FooterActionIcon,
        null,
        _react2.default.createElement(_nitroIcon2.default, { name: icon, size: 12, variant: 'white' })
      )
    );
  }

  return _react2.default.createElement(
    DrawerAction,
    { width: width, open: isOpen },
    _react2.default.createElement(
      DrawerButtonGroup,
      null,
      _react2.default.createElement(
        _nitroButtonGroup2.default,
        { layout: 'horizontal', inline: true },
        _react2.default.createElement(
          LeftActionGroup,
          { width: width },
          getActions(left, labelVariant)
        ),
        _react2.default.createElement(
          RightActionGroup,
          { width: width },
          getActions(right, labelVariant)
        ),
        _react2.default.createElement(
          ShortLeftActionGroup,
          { width: width },
          getShortActions(left, labelVariant)
        ),
        _react2.default.createElement(
          ShortRightActionGroup,
          { width: width },
          getShortActions(right, labelVariant)
        )
      )
    )
  );
};
NitroDrawerFooter.propTypes = {
  actionFooter: _propTypes2.default.object,
  actions: _propTypes2.default.object,
  width: _propTypes2.default.number,
  isOpen: _propTypes2.default.bool,
  close: _propTypes2.default.func,
  action: _propTypes2.default.func,
  actionLabel: _propTypes2.default.string,
  cancelAction: _propTypes2.default.func,
  cancelLabel: _propTypes2.default.string,
  labelVariant: _propTypes2.default.string
};

exports.default = NitroDrawerFooter;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-drawer/NitroDrawerFooter.js
// module id = 2905
// module chunks = 4